// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__poLFC","modal":"modal_modal__lKxcH","form":"modal_form__EkWn4","label":"modal_label__xQllo"};